import { Tooltip } from 'component-library';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../../contexts/AppContext';
import { LatestSoftwareVersion, SystemDetail } from '../../../models/ApiModels';
import SystemDetailsSoftwareVersion from './SystemDetailsConfiguration/SystemDetailsSoftwareVersion';

interface Props {
  system: SystemDetail;
  latestSoftwareVersion?: LatestSoftwareVersion;
}

export default function SystemDetailsHardwareControlUnit(props: Props) {
  const { isHumphreeUser } = useContext(AppContext);

  return (
    <div className='border-b border-gray-10'>
      <div className='flex gap-2 my-3'>
        <span className='prose-heading5'>Lightning control unit</span>
        <Tooltip description='The Lightning control unit controls the interceptors and houses the license file and the software for all the functions.' />
      </div>
      <div className='xl:flex xl:justify-between my-5 items-center'>
        <div className='xl:block hidden w-48'>Lightning control unit</div>
        <div className='2xl:gap-16 xl:flex gap-4'>
          <div className='w-32 flex justify-between items-center truncate'></div>
          {props.system.lightningHardwareSystem?.controlUnit?.articleNumber && (
            <div className='text-left w-42 flex justify-between items-center'>
              Part no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {props.system.lightningHardwareSystem?.controlUnit?.articleNumber?.toString()}
              </span>
            </div>
          )}
          {props.system.lightningHardwareSystem?.controlUnitSerial && (
            <div className='text-left xl:w-32 flex justify-between items-center'>
              Serial no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {isHumphreeUser ? (
                  <Link
                    to={'/units/lhs/' + props.system.lightningHardwareSystem?.controlUnitSerial}
                    className='whitespace-nowrap cursor-pointer underline text-primary-100 hover:text-primary-200'
                  >
                    {props.system.lightningHardwareSystem?.controlUnitSerial?.toString()}
                  </Link>
                ) : (
                  props.system.lightningHardwareSystem?.controlUnitSerial?.toString()
                )}
              </span>
            </div>
          )}
          <div className='xl:w-42 flex justify-between items-center'>
            Software
            <span className='font-code prose-dataBaseDataLabel ml-3 xl:w-12 xl:truncate'>
              {props.system.lightningHardwareSystem?.controlUnit?.firmwareVersion}
            </span>
          </div>
          <SystemDetailsSoftwareVersion
            latestSoftwareVersion={props.latestSoftwareVersion}
            unitType='LCU'
            system={props.system}
          />
        </div>
      </div>
    </div>
  );
}
